import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRouteSnapshot, Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-form-page',
  templateUrl: './password-form-page.component.html',
  styleUrls: ['./password-form-page.component.scss']
})
export class PasswordFormPageComponent implements OnInit {
  mode: string;
  email: string;
  code: string;
  apiKey: string;
  continueUrl: string;

  codeError = false;
  updateError = false;
  updateSuccess = false;

  form = new FormGroup({
    password: new FormControl('', Validators.required)
  });

  constructor(private auth: AngularFireAuth, private route: ActivatedRoute, private router: Router) {}
  async ngOnInit() {
    this.mode = this.route.snapshot.queryParamMap.get('mode');
    this.code = this.route.snapshot.queryParamMap.get('oobCode');
    this.apiKey = this.route.snapshot.queryParamMap.get('apiKey');
    this.continueUrl = this.route.snapshot.queryParamMap.get('continueUrl');

    if (this.mode === 'resetPassword' && this.code && this.apiKey) {
      try {
        this.email = await this.auth.auth.verifyPasswordResetCode(this.code);
        console.log(this.email);
      } catch (e) {
        console.log(e);
        this.codeError = true;
      }
    } else {
      this.codeError = true;
    }
  }

  async updatePassword() {
    const password = this.form.value.password;
    try {
      await this.auth.auth.confirmPasswordReset(this.code, password);

      if (this.continueUrl) {
        location.href = this.continueUrl;
      } else {
        const user = await this.auth.auth.signInAndRetrieveDataWithEmailAndPassword(this.email, password);
        this.updateSuccess = true;
      }
    } catch (e) {
      alert(e);
      this.updateError = true;
    }
  }
}
